/**
 * Enums partilhados entre frontend e backend.
 * Devem espelhar os enums definidos em backend/prisma/schema.prisma.
 * Se alterar um, alterar o outro.
 */
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["COMPANY_ADMIN"] = "COMPANY_ADMIN";
    UserRole["COMPANY_MANAGER"] = "COMPANY_MANAGER";
    UserRole["COMPANY_OPERATOR"] = "COMPANY_OPERATOR";
    UserRole["COMPANY_VIEWER"] = "COMPANY_VIEWER";
})(UserRole || (UserRole = {}));
export var PlanTier;
(function (PlanTier) {
    PlanTier["FREE"] = "FREE";
    PlanTier["STARTER"] = "STARTER";
    PlanTier["PRO"] = "PRO";
    PlanTier["ENTERPRISE"] = "ENTERPRISE";
})(PlanTier || (PlanTier = {}));
export var PlanStatus;
(function (PlanStatus) {
    PlanStatus["ACTIVE"] = "ACTIVE";
    PlanStatus["INACTIVE"] = "INACTIVE";
    PlanStatus["ARCHIVED"] = "ARCHIVED";
})(PlanStatus || (PlanStatus = {}));
export var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ACTIVE"] = "ACTIVE";
    CompanyStatus["SUSPENDED"] = "SUSPENDED";
    CompanyStatus["TRIAL"] = "TRIAL";
    CompanyStatus["CANCELED"] = "CANCELED";
})(CompanyStatus || (CompanyStatus = {}));
export var WhatsAppConnectionStatus;
(function (WhatsAppConnectionStatus) {
    WhatsAppConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
    WhatsAppConnectionStatus["CONNECTING"] = "CONNECTING";
    WhatsAppConnectionStatus["CONNECTED"] = "CONNECTED";
    WhatsAppConnectionStatus["QR_PENDING"] = "QR_PENDING";
    WhatsAppConnectionStatus["LOGGED_OUT"] = "LOGGED_OUT";
    WhatsAppConnectionStatus["BANNED"] = "BANNED";
    WhatsAppConnectionStatus["ERROR"] = "ERROR";
})(WhatsAppConnectionStatus || (WhatsAppConnectionStatus = {}));
export var GroupRole;
(function (GroupRole) {
    GroupRole["SOURCE"] = "SOURCE";
    GroupRole["DESTINATION"] = "DESTINATION";
    GroupRole["BOTH"] = "BOTH";
})(GroupRole || (GroupRole = {}));
/** Estado de uma regra de espelhamento (feature 25: pausar/ativar). */
export var MirrorRuleStatus;
(function (MirrorRuleStatus) {
    MirrorRuleStatus["ACTIVE"] = "ACTIVE";
    MirrorRuleStatus["PAUSED"] = "PAUSED";
    MirrorRuleStatus["ARCHIVED"] = "ARCHIVED";
})(MirrorRuleStatus || (MirrorRuleStatus = {}));
/** Origem de um link de afiliado (feature 15: API oficial vs manual/importado). */
export var AffiliateLinkSource;
(function (AffiliateLinkSource) {
    AffiliateLinkSource["API"] = "API";
    AffiliateLinkSource["MANUAL"] = "MANUAL";
    AffiliateLinkSource["IMPORTED"] = "IMPORTED";
})(AffiliateLinkSource || (AffiliateLinkSource = {}));
/** Estado de um link encurtado próprio (feature 28). */
export var ShortLinkStatus;
(function (ShortLinkStatus) {
    ShortLinkStatus["ACTIVE"] = "ACTIVE";
    ShortLinkStatus["DISABLED"] = "DISABLED";
    ShortLinkStatus["EXPIRED"] = "EXPIRED";
})(ShortLinkStatus || (ShortLinkStatus = {}));
export var Marketplace;
(function (Marketplace) {
    Marketplace["SHOPEE"] = "SHOPEE";
    Marketplace["MERCADO_LIVRE"] = "MERCADO_LIVRE";
    Marketplace["OTHER"] = "OTHER";
})(Marketplace || (Marketplace = {}));
export var OfferStatus;
(function (OfferStatus) {
    OfferStatus["DRAFT"] = "DRAFT";
    OfferStatus["PENDING"] = "PENDING";
    OfferStatus["QUEUED"] = "QUEUED";
    OfferStatus["SENT"] = "SENT";
    OfferStatus["FAILED"] = "FAILED";
    OfferStatus["CANCELED"] = "CANCELED";
    OfferStatus["SCHEDULED"] = "SCHEDULED";
})(OfferStatus || (OfferStatus = {}));
/** Origem de uma oferta (manual, espelhamento automático, importação em lote). */
export var OfferSource;
(function (OfferSource) {
    OfferSource["MANUAL"] = "MANUAL";
    OfferSource["MIRRORED"] = "MIRRORED";
    OfferSource["BATCH"] = "BATCH";
    OfferSource["IMPORTED"] = "IMPORTED";
    // Criada automaticamente pelo agente IA (descoberta + ranking + agendamento).
    OfferSource["AGENT"] = "AGENT";
    // Criada manualmente com enriquecimento IA aplicado (paste URL com IA).
    OfferSource["AI_ASSISTED"] = "AI_ASSISTED";
})(OfferSource || (OfferSource = {}));
/** Estado de uma campanha de envio recorrente (scheduler). */
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["ACTIVE"] = "ACTIVE";
    CampaignStatus["PAUSED"] = "PAUSED";
    CampaignStatus["ARCHIVED"] = "ARCHIVED";
})(CampaignStatus || (CampaignStatus = {}));
/** Estado de um job de descoberta executado pelo agente IA. */
export var AgentJobStatus;
(function (AgentJobStatus) {
    AgentJobStatus["PENDING"] = "PENDING";
    AgentJobStatus["RUNNING"] = "RUNNING";
    AgentJobStatus["SUCCEEDED"] = "SUCCEEDED";
    AgentJobStatus["PARTIAL"] = "PARTIAL";
    AgentJobStatus["FAILED"] = "FAILED";
    AgentJobStatus["CANCELLED"] = "CANCELLED";
})(AgentJobStatus || (AgentJobStatus = {}));
/** Tipo de mídia anexada a uma oferta. */
export var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["DOCUMENT"] = "DOCUMENT";
    MediaType["AUDIO"] = "AUDIO";
    MediaType["STICKER"] = "STICKER";
    MediaType["NONE"] = "NONE";
})(MediaType || (MediaType = {}));
export var MessageLogType;
(function (MessageLogType) {
    MessageLogType["RECEIVED"] = "RECEIVED";
    MessageLogType["PROCESSED"] = "PROCESSED";
    MessageLogType["SENT"] = "SENT";
    MessageLogType["ERROR"] = "ERROR";
    MessageLogType["SKIPPED"] = "SKIPPED";
})(MessageLogType || (MessageLogType = {}));
// Nota: AffiliateProvider não tem OTHER (ao contrário de Marketplace) porque
// marketplaces "OTHER" não têm programa de afiliados suportado.
export var AffiliateProvider;
(function (AffiliateProvider) {
    AffiliateProvider["SHOPEE"] = "SHOPEE";
    AffiliateProvider["MERCADO_LIVRE"] = "MERCADO_LIVRE";
})(AffiliateProvider || (AffiliateProvider = {}));
export var CredentialStatus;
(function (CredentialStatus) {
    CredentialStatus["ACTIVE"] = "ACTIVE";
    CredentialStatus["INVALID"] = "INVALID";
    CredentialStatus["EXPIRED"] = "EXPIRED";
    CredentialStatus["PENDING"] = "PENDING";
})(CredentialStatus || (CredentialStatus = {}));
export var TemplateType;
(function (TemplateType) {
    TemplateType["OFFER"] = "OFFER";
    TemplateType["SHOPEE"] = "SHOPEE";
    TemplateType["MERCADO_LIVRE"] = "MERCADO_LIVRE";
    TemplateType["GENERIC"] = "GENERIC";
})(TemplateType || (TemplateType = {}));
/** Permissões granulares usadas pelo RBAC. */
export var Permission;
(function (Permission) {
    // Company scope
    Permission["COMPANY_MANAGE"] = "company:manage";
    Permission["USER_MANAGE"] = "user:manage";
    // WhatsApp
    Permission["WHATSAPP_CONNECT"] = "whatsapp:connect";
    Permission["WHATSAPP_VIEW"] = "whatsapp:view";
    Permission["WHATSAPP_MANAGE"] = "whatsapp:manage";
    // Mirror rules
    Permission["RULE_MANAGE"] = "rule:manage";
    Permission["RULE_VIEW"] = "rule:view";
    // Offers
    Permission["OFFER_CREATE"] = "offer:create";
    Permission["OFFER_MANAGE"] = "offer:manage";
    Permission["OFFER_VIEW"] = "offer:view";
    // Templates
    Permission["TEMPLATE_MANAGE"] = "template:manage";
    // Affiliate
    Permission["AFFILIATE_VIEW"] = "affiliate:view";
    Permission["AFFILIATE_MANAGE"] = "affiliate:manage";
    // Templates (leitura para operadores aplicarem ao criar ofertas)
    Permission["TEMPLATE_VIEW"] = "template:view";
    // Dashboard / logs
    Permission["DASHBOARD_VIEW"] = "dashboard:view";
    Permission["LOGS_VIEW"] = "logs:view";
    // SaaS admin
    Permission["SAAS_ADMIN"] = "saas:admin";
})(Permission || (Permission = {}));
/** Conjunto de permissões por papel. */
export const ROLE_PERMISSIONS = {
    [UserRole.SUPER_ADMIN]: Object.values(Permission),
    [UserRole.COMPANY_ADMIN]: [
        Permission.COMPANY_MANAGE,
        Permission.USER_MANAGE,
        Permission.WHATSAPP_CONNECT,
        Permission.WHATSAPP_VIEW,
        Permission.WHATSAPP_MANAGE,
        Permission.RULE_MANAGE,
        Permission.RULE_VIEW,
        Permission.OFFER_CREATE,
        Permission.OFFER_MANAGE,
        Permission.OFFER_VIEW,
        Permission.TEMPLATE_VIEW,
        Permission.TEMPLATE_MANAGE,
        Permission.AFFILIATE_VIEW,
        Permission.AFFILIATE_MANAGE,
        Permission.DASHBOARD_VIEW,
        Permission.LOGS_VIEW,
    ],
    [UserRole.COMPANY_MANAGER]: [
        Permission.WHATSAPP_VIEW,
        Permission.WHATSAPP_MANAGE,
        Permission.RULE_MANAGE,
        Permission.RULE_VIEW,
        Permission.OFFER_CREATE,
        Permission.OFFER_MANAGE,
        Permission.OFFER_VIEW,
        Permission.TEMPLATE_VIEW,
        Permission.TEMPLATE_MANAGE,
        Permission.AFFILIATE_VIEW,
        Permission.AFFILIATE_MANAGE,
        Permission.DASHBOARD_VIEW,
        Permission.LOGS_VIEW,
    ],
    // Operador: cria E gere as próprias ofertas, consulta templates/afiliados
    // e vê logs para troubleshooting.
    [UserRole.COMPANY_OPERATOR]: [
        Permission.WHATSAPP_VIEW,
        Permission.RULE_VIEW,
        Permission.OFFER_CREATE,
        Permission.OFFER_MANAGE,
        Permission.OFFER_VIEW,
        Permission.TEMPLATE_VIEW,
        Permission.AFFILIATE_VIEW,
        Permission.DASHBOARD_VIEW,
        Permission.LOGS_VIEW,
    ],
    [UserRole.COMPANY_VIEWER]: [
        Permission.WHATSAPP_VIEW,
        Permission.RULE_VIEW,
        Permission.OFFER_VIEW,
        Permission.TEMPLATE_VIEW,
        Permission.AFFILIATE_VIEW,
        Permission.DASHBOARD_VIEW,
    ],
};
//# sourceMappingURL=enums.js.map